import React from 'react'
import { IconButton, IconButtonProps } from '@material-ui/core'

export const IconButtonUly: React.FC<IconButtonProps> = React.memo(
    ({ children, ...props }) => <IconButton {...props}>{children}</IconButton>
)

IconButtonUly.displayName = 'IconButtonUly'
